import {Component} from 'react';

import DialogService from '-/services/DialogService';
import Dialog from './Dialog';
import Button from '-/components/general/Button';

class CoAppReminderDialog extends Component {
    handleDialogClose = () => {
        DialogService.show(false);
    };

    render() {
        return (
            <Dialog>
                <h1>CO-APPLICANT NEEDED</h1>
                <p className="info">
                    A co-applicant with an income is required in order to submit
                    this loan. Please add a co-applicant after you review your
                    information. You cannot submit this application without
                    a co-applicant.
                </p>
                <section className="steps-buttons">
                    <div className="row">
                        <Button onClick={this.handleDialogClose}>OK</Button>
                    </div>
                </section>
            </Dialog>
        );
    }
}

export default CoAppReminderDialog;
